export default "__VITE_ASSET__C84d_ziX__"